<template>
    <div class="card" style="min-height: 450px; overflow-y: scroll;">
        <div class="card-header py-2">
            <h6 class="" style="color:#348cd4;"> Agent Details</h6>
        </div>
        <div class="row card-body">
            <!-- Agents section -->
            <section class="container ">
                <div class="d-flex justify-content-center row ">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Company Name</label>
                        <div class="">
                            <input class="form-control form-control-sm" type="text" v-model="agentDetails.companyName">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Agent ID</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.agentId">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center row">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Email</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.email">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Phone</label>
                        <div class="">
                            <input class="form-control form-control-sm" type="text" v-model="agentDetails.phone">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center row">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Address</label>
                        <div class="">
                            <input class="form-control form-control-sm" type="text" v-model="agentDetails.address">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">City</label>
                        <div class="">
                            <input class="form-control form-control-sm" type="text" v-model="agentDetails.city">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center row">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">State</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.stateAddress">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">User type</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.userType">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center row">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Company RC</label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <b class="input-group-text" id="addon-wrapping">RC</b>
                            </div>
                            <input class="form-control " type="text" disabled v-model="agentDetails.companyRc">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Tax ID number</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.taxId">
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center row">
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Account status</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.accountStatus">
                        </div>
                    </div>
                    <div class="form-group col-sm-10 col-md-6 col-lg-5 mb-4">
                        <label class="font-weight-bold mb-1">Created by</label>
                        <div class="">
                            <input class="form-control form-control-sm" disabled type="text" v-model="agentDetails.createdBy">
                        </div>
                    </div>
                </div><br>
                <div class="d-flex justify-content-end">
                    <button v-show="agentDetails.accountStatus == 'Active'" class="btn btn-sm mr-2 btn-primary" @click="updateAgent">Update</button>
                    
                    <button v-if="agentDetails.accountStatus == 'Active'" class="btn btn-sm mr-2 btn-secondary" @click="suspendAgent">Suspend</button>
                    <button v-else class="btn btn-sm mr-2 btn-secondary" @click="unSuspendAgent">Un-suspend</button>
                    
                    <button class="btn btn-sm mr-2 btn-danger" @click="deleteAgent">Delete</button>
                </div>

            </section>

            <!-- Subagent section -->
            <section class="container">
                <br><hr>
                <p class="card-header" style="color:#348cd4;">Sub Agents</p>

                <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config">
                    <template slot="id" slot-scope="props">
                        <span>
                            {{props.row.vbt_id}}
                        </span>
                    </template>
                    <template slot="surname" slot-scope="props">
                        <span>
                            {{props.cell_value}}
                        </span>
                    </template>
                    <template slot="accountStatus" slot-scope="props">
                        <span v-if="props.cell_value ==0">
                            Not Verified
                        </span>
                        <span v-if="props.cell_value ==1">
                            Verified
                        </span>
                    </template>
                    <template slot="stateCode" slot-scope="props">
                        <span>
                            {{$store.getters.stateName(props.cell_value)}}
                        </span>
                    </template>
                    <template slot="branchCode" slot-scope="props">
                        <span>
                            {{props.cell_value}}
                        </span>
                    </template>
                    <template slot="setup" slot-scope="props">
                        <span>
                            <a @click="gotosettins(props.cell_value)"  class="btn btn-primary disabled btn-xs" style="font-size:10px" ><v-icon name="settings" style="width:14px; color:#fff"></v-icon></a>
                        </span>
                    </template>
                    <template slot="sort-asc-icon">
                        <i class="fas fa-sort-up"></i>
                    </template>
                    <template slot="sort-desc-icon">
                        <i class="fas fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                        <i class="fas fa-sort"></i>
                    </template>
                </vue-bootstrap4-table>
            </section>
        </div>
    </div>
</template>


<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import { mapState, mapActions } from 'vuex';

export default {
    name: 'ShowAgent',
    props:['agentId'],
    components:{
        VueBootstrap4Table
    },
    data() {
        return{
            showList: true,
            agentDetails: {
                companyName: 'N/A', agentId: 'N/A', email: 'N/A', 
                phone: 'N/A', compantRc: 'N/A', taxId: 'N/A', 
                accountStatus: 'Active', city: 'N/A', address: 'N/A', 
                stateAddress: 'N/A', userType: 'N/A', createdBy: 'N/A'
            },
            rows: [],
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Sub-Agent Id",
                    name: "subagentId",
                    sort: true,
                },
                {
                label: "Surname",
                    name: "Users.firstName",
                    slot_name: "surname",
                    sort: true,
                },
                {
                    label: "Name",
                    name: "Users.lastName",
                    sort: true,
                },
                {
                    label: "Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Phone",
                    name: "phone",
                    sort: true,
                },
                {
                    label: "Status",
                    name: "Users.accountVerified",
                    slot_name: "accountStatus",
                    sort: true,
                },
                {
                    label: "State",
                    name: "stateCode",
                    sort: true,
                    slot_name: "stateCode"
                },
                {
                    label: "Branch code",
                    name: "branchCode",
                    sort: true,
                    slot_name: "branchCode"
                },
                {
                    label: "Action",
                    name: "subagentId",
                    sort: true,
                    slot_name: "setup"
                },
            ],
            config: {
                card_mode: false,
                checkbox_rows: false,
                rows_selectable: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search Sub-agent",
                    visibility: true,
                    case_sensitive: false,
                },
            }
        }
    },
    computed:{
        ...mapState(['token'])
    },
    mounted(){
        const baseU = `${this.$urlAuth}/agent/${this.agentId}`

        this.$http.get(baseU,{
            headers:{
                "x-access-token":this.token
            }
        })
        .then(response => {
            if(response.data.data.code == 'S200'){
                this.agentDetails = response.data.data.agents
                this.rows = response.data.data.subagents

                this.agentDetails.createdBy = (response.data.data.agents.createdBy)? response.data.data.agents.createdBy : 'Self' 
                this.agentDetails.userType = (response.data.data.agents.userType == 1)? "Agent" : 'N/A' 
                this.agentDetails.accountStatus = (response.data.data.agents.accountStatus == 1)? "Active" : 'Suspended' 
            }else{
                this.$toastr.e(response.data.data.message);
                this.rows = [];
            }
        })
    },
    methods: {
        ...mapActions(['update_refreshAgentsList']),

        updateAgent() {
            const baseU = `${this.$urlAuth}/agent/update`

            this.$http.post(baseU,
            {
                agentId: this.agentDetails.agentId,
                companyName: this.agentDetails.companyName,
                email: this.agentDetails.email,
                phone: this.agentDetails.phone,
                address: this.agentDetails.address,
                city: this.agentDetails.city
            },{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code == 'S200'){
                    this.$toastr.s(response.data.data.message);

                    this.update_refreshAgentsList(true)
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(e => {
               this.$toastr.e('Network error, unable to connect'); 
            })
        },

        suspendAgent() {
            if (!confirm('Are you sure you want to suspend this agent?')) {
                return
            }
            const baseU = `${this.$urlAuth}/agent/suspendone`

            this.$http.post(baseU,{agentId: this.agentDetails.agentId},{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code == 'S200'){
                    this.$toastr.s(response.data.data.message);

                    this.agentDetails.accountStatus = 'Suspended'

                    // refresh agents list
                    this.update_refreshAgentsList(true)
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(e => {
               this.$toastr.e('Network error, unable to connect'); 
            })
        },

        unSuspendAgent() {
            if (!confirm('Are you sure you want to un-suspend this agent?')) {
                return
            }
            const baseU = `${this.$urlAuth}/agent/unsuspend`

            this.$http.post(baseU,{agentId: this.agentDetails.agentId},{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code == 'S200'){
                    this.$toastr.s(response.data.data.message);

                    this.agentDetails.accountStatus = 'Active'

                    // Refresh the agents list
                    this.update_refreshAgentsList(true)
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(e => {
               this.$toastr.e('Network error, unable to connect'); 
            })
        },

        deleteAgent() {
            const deleteEmail = prompt('Are you sure you want to delete this agent? \nType the email of the agent to comfirm')
            if (deleteEmail != this.agentDetails.email) {
                return
            }
            const baseU = `${this.$urlAuth}/agent/deleteone`

            this.$http.post(baseU,{agentId: this.agentDetails.agentId},{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code == 'S200'){
                    this.$toastr.s(response.data.data.message);

                    // refresh agents list
                    this.update_refreshAgentsList(true)

                    // tell parent to hide agent's details and show agents list component
                    this.$emit('showList', true)
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(e => {
               this.$toastr.e('Network error, unable to connect deleted'); 
            })
        }
    }
}
</script>